"use client";

import {useSessionHeartbeat} from "@/hooks/useSessionHeartbeat";

export function SessionHeartbeatProvider() {
    useSessionHeartbeat(60000); // 1 minute
    return null;
}
